import React, { ReactNode } from "react";
import IconButton from "@material-ui/core/IconButton";
import TwitterIcon from "assets/svgs/icons/socialMedia/TwitterIcon";
import FacebookIcon from "assets/svgs/icons/socialMedia/FacebookIcon";
import InstagramIcon from "assets/svgs/icons/socialMedia/InstagramIcon";
import YouTubeIcon from "assets/svgs/icons/socialMedia/YouTubeIcon";
import DiscordIcon from "assets/svgs/icons/socialMedia/DiscordIcon";

import NewTabLink from "./links/NewTabLink";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { transition, socialMediaColours } from "theme";
import links from "links";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    const hoverBackgroundColour = theme.palette.common.white;

    return createStyles({
        root: {
            display: "flex",
        },
        icon: {
            color: theme.palette.common.white,
            transition: theme.transitions.create("all", {
                duration: transition.duration,
                easing: theme.transitions.easing.easeInOut,
            }),
        },
        twitter: {
            "&:hover": {
                color: socialMediaColours.twitter,
                backgroundColor: hoverBackgroundColour,
            },
        },
        facebook: {
            "&:hover": {
                color: socialMediaColours.facebook,
                backgroundColor: hoverBackgroundColour,
            },
        },
        youtube: {
            "&:hover": {
                color: socialMediaColours.youtube,
                backgroundColor: hoverBackgroundColour,
            },
        },
        instagram: {
            "&:hover": {
                color: socialMediaColours.instagram,
                backgroundColor: hoverBackgroundColour,
            },
        },
        discord: {
            "&:hover": {
                color: socialMediaColours.discord,
                backgroundColor: hoverBackgroundColour,
            },
        },
    });
});

interface IIconLink {
    icon: ReactNode;
    link: string;
    className?: string;
}

export default function SocialMediaIcons() {
    const classes = useStyles();

    const iconLinks: IIconLink[] = [
        {
            icon: <TwitterIcon />,
            link: links.socialMedia.twitter,
            className: classes.twitter,
        },
        {
            icon: <FacebookIcon />,
            link: links.socialMedia.facebook,
            className: classes.facebook,
        },
        {
            icon: <YouTubeIcon />,
            link: links.socialMedia.youtube,
            className: classes.youtube,
        },
        {
            icon: <InstagramIcon />,
            link: links.socialMedia.instagram,
            className: classes.instagram,
        },
        {
            icon: <DiscordIcon />,
            link: links.socialMedia.discord,
            className: classes.discord,
        },
    ];

    return (
        <div className={classes.root}>
            {iconLinks.map((iconLink: IIconLink, i) => {
                const { link, icon, className = "" } = iconLink;
                return (
                    <NewTabLink key={i} href={link} style={{ borderRadius: "50%" }}>
                        <IconButton color="inherit" className={clsx(classes.icon, className)}>
                            {icon}
                        </IconButton>
                    </NewTabLink>
                );
            })}
        </div>
    );
}
